import { NavLink, useLocation } from "react-router-dom";
import { Home, Target, FileText, LayoutDashboard, User, Settings } from "lucide-react";
import { cn } from "@/lib/utils";
import { useAuth } from "@/hooks/useAuth";

const navItems = [
  {
    label: "Home",
    path: "/",
    icon: Home,
  },
  {
    label: "Study",
    path: "/study",
    icon: FileText,
    requireAuth: true,
  },
  {
    label: "Practice",
    path: "/practice",
    icon: Target,
    requireAuth: true,
  },
  {
    label: "Dashboard",
    path: "/dashboard",
    icon: LayoutDashboard,
    requireAuth: true,
  },
  {
    label: "Settings",
    path: "/settings",
    icon: Settings,
    requireAuth: true,
  },
  {
    label: "Account",
    path: "/auth",
    icon: User,
    guestOnly: true,
  },
];

export function MobileBottomNav() {
  const location = useLocation();
  const { user } = useAuth();

  // Don't show on auth page or admin pages
  if (location.pathname === '/auth' || location.pathname.startsWith('/admin')) {
    return null;
  }

  const visibleItems = navItems.filter(item => {
    if (item.requireAuth && !user) return false;
    if (item.guestOnly && user) return false;
    return true;
  });

  // Only show on mobile
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border safe-area-inset-bottom">
      <div className="flex items-center justify-around h-16 px-2">
        {visibleItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path || 
                          (item.path !== '/' && location.pathname.startsWith(item.path));

          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={cn(
                "flex flex-col items-center justify-center gap-1 px-3 py-2 rounded-lg transition-all min-w-[64px]",
                "active:scale-95",
                isActive
                  ? "text-primary bg-primary/10"
                  : "text-muted-foreground hover:text-foreground hover:bg-muted/50"
              )}
            >
              <Icon className={cn("h-5 w-5", isActive && "scale-110")} />
              <span className="text-xs font-medium">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
